import React, { useContext, useEffect, useState } from "react";
import styles from "./MultipleEmailMarketing.module.css";
import { lapContext } from "../../context/OverLapContext";
import FormSelect from "../utilities/formSelect/FormSelect";

import Button from "../utilities/button/Button";
import { FaCircleCheck } from "react-icons/fa6";
import { IoCloseCircle } from "react-icons/io5";

function MultipleEmailMarketing() {
  // eslint-disable-next-line no-unused-vars
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [html, setHtml] = useState("");
  const [btnStatus, setBtnStatus] = useState("Send");
  const { SetIsSuccess } = useContext(lapContext);
  const [inputStatus, setInputStatus] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [emailArray, setEmailArray] = useState([]);
  const [emailArrayResponse, setEmailArrayResponse] = useState(
    "No Email Array Created"
  );
  const [apiResponse, setApiResponse] = useState(false);
  const [emailSentResponse, setemailSentResponse] = useState("");
  const [emailSentBoolean, setEmailSentBoolean] = useState(false);

  //Iframe

  function getSubject(e) {
    setSubject(e.target.value);
  }

  function getHtml(e) {
    setHtml(e.target.value);
  }

  function selectHandler(e) {
    setSelectEmail(e.target.value);
  }

  useEffect(() => {
    async function getCountry() {
      try {
        const result = await fetch(
          `https://artmadein-dashboard-backend.onrender.com/api/v1/client/clientcountry`,
          // `http://localhost:5000/api/v1/client/clientcountry`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const data = await result.json();
        console.log(data);
        setCountryList(data?.data?.stats);
      } catch (err) {
        console.log(err);
      }
    }

    getCountry();
  }, []);

  // form submit
  async function formSubmit(e) {
    e.preventDefault();

    setBtnStatus("Sending....");
    setInputStatus(true);

    const response = await fetch(
      `https://artmadein-dashboard-backend.onrender.com/api/v1/client/sentmultipleemail`,
      // `http://localhost:5000/api/v1/client/sentmultipleemail`,
      {
        method: "POST",
        body: JSON.stringify({ emailArray, subject, html }),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      setBtnStatus("Send");
    }

    if (response.ok) {
      setBtnStatus("Send");
      SetIsSuccess(true);
      setInputStatus(false);
      setEmail("");
      setSubject("");
    }

    const message = await response.json();

    setemailSentResponse(message.message);
    setEmailSentBoolean(response.ok);

    // const resData = await response.json();
    // THIS V2 BRANCH
  }

  // Send Email Array Request
  async function GenerateArray(e) {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/client/emailarray`,
        // `http://localhost:5000/api/v1/client/emailarray`,
        {
          method: "POST",
          body: JSON.stringify({ selectEmail }),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      const data = await response.json();
      setApiResponse(response.ok);
      setEmailArrayResponse(data.message);
      setEmailArray(data?.data?.stats[0]?.emails);
    } catch (err) {
      console.log(err);
    }
  }
  console.log("emailArray", emailArray, "CountryList", countryList);
  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.formbox}>
          <form
            style={{ marginBottom: "20px" }}
            className={styles.form}
            onSubmit={GenerateArray}
          >
            <div>
              <label htmlFor="email">Select The Country</label>
              <select
                id="country"
                name="country"
                onChange={selectHandler}
                value={selectEmail}
              >
                <option value={"null"}>{"Select"}</option>
                {countryList.map((data, index) => {
                  return (
                    <FormSelect
                      key={index}
                      country={data._id}
                      number={data.count}
                    ></FormSelect>
                  );
                })}
              </select>
              <br></br>
              <br></br>
              <div style={{ marginBottom: "10px" }}>
                <Button disabled={selectEmail === "null" || selectEmail === ""}>
                  Create Email Array
                </Button>
              </div>
            </div>
            <p
              className={
                apiResponse
                  ? `${styles.apiResponsePass}`
                  : `${styles.apiResponseFailed}`
              }
            >
              {emailArrayResponse}{" "}
              {apiResponse ? (
                <FaCircleCheck></FaCircleCheck>
              ) : (
                <IoCloseCircle></IoCloseCircle>
              )}
            </p>
          </form>
          <form onSubmit={formSubmit} className={styles.form}>
            <div>
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={subject}
                onChange={getSubject}
                disabled={inputStatus}
              ></input>
            </div>
            <div>
              <label htmlFor="htmlcode">HTML Code</label>
              <textarea
                name="htmlcode"
                placeholder="Paste Your HTML Code"
                value={html}
                onChange={getHtml}
                disabled={inputStatus}
              ></textarea>
            </div>
            <button
              className={
                emailArray.length === 0 ||
                subject.length === 0 ||
                html.length === 0
                  ? styles.btnDisabled
                  : styles.btn
              }
              disabled={
                emailArray.length === 0 ||
                subject.length === 0 ||
                html.length === 0
              }
            >
              {btnStatus}
            </button>{" "}
            {emailSentBoolean ? (
              <span style={{ color: "green" }}>
                {emailSentResponse} <FaCircleCheck></FaCircleCheck>
              </span>
            ) : (
              <span style={{ color: "red" }}>
                {emailSentResponse} <IoCloseCircle></IoCloseCircle>
              </span>
            )}
          </form>
          <iframe
            title="emailer"
            height="300"
            width="100%"
            srcDoc={html}
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default MultipleEmailMarketing;
